import { render, staticRenderFns } from "./TheModalDetalleTratamiento.vue?vue&type=template&id=8a4b8464&scoped=true&"
import script from "./TheModalDetalleTratamiento.vue?vue&type=script&lang=js&"
export * from "./TheModalDetalleTratamiento.vue?vue&type=script&lang=js&"
import style0 from "./TheModalDetalleTratamiento.vue?vue&type=style&index=0&id=8a4b8464&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4b8464",
  null
  
)

export default component.exports